import HomeCard from "./homeCard";
import PopUpFormSupport from "../../../popUpForms/popUpFormContact";
const CardNeedSupport = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="contact"
      title="Need Support? We can Help!"
      titleColor="var(--orange)"
      popUpComponent={<PopUpFormSupport />}
      content={[
        {
          type: "header-H5",
          text: "Need assistance?",
          color: "var(--gold)",
        },
        {
          type: "paragraph",
          text: "Schedule a meeting with us, together we can assess the best ways to support you. We offer workshops, webinars, on-the ground pilots, and more.",
          color: "var(--white)",
        },
        {
          type: "paragraph",
          text: 'For more information please visit <a href="/scorecard/faq">Frequently Asked Questions (FAQs)</a> page.',
          color: "var(--shite)",
        },
        { type: "button", color: "var(--orange)", text: "Contact Us" },
      ]}
    />
  );
};

export default CardNeedSupport;
